import * as d3 from 'd3-selection'
import fontSize from './font-size.js'
import tweener from './text-tween.js'
import yPos from './y-text-position.js'

// we want slightly smaller padding than the global padding
const paddingOverridePercent = 0.85

export default function (id, dimensions) {

  var draw = function (selection) {
    selection.each(function () {
      // Add a group container for the value
      let group = d3.select(this)
                    .selectAll('g.text-group-value').data(function (d) {
                      return d.value && d.value.formatted && !d.explanation ? [d.value.formatted] : []
                    })
        , _group = group.enter()
                         .append('g')
                           .attr('class', 'text-group-value')
                           .merge(group)
                           .attr('transform', `translate(${dimensions.padding.left * paddingOverridePercent},0)`)


      let av = _group.selectAll('text').data(d => [d])
        , _av = av.enter()
                  .append('text')
                    .attr('class', 'value label-on-colored-background dark')
                    .text(String)
                    .style('font-size', function (d) {
                      return fontSize(this, d, 'value', dimensions.viewbox.width / 2, 24)
                    })
                    .attr('y', function (d) {
                      return yPos(parseFloat(d3.select(this).style('font-size')), dimensions.header.height)
                    })
                    .merge(av)

      _av.attr('data-fs', function (d) {
            return fontSize(this, d, 'value', dimensions.viewbox.width / 2, 24)
         })
         .transition()
         .duration(300)
         .tween('value-text-tween', function (d) {
           return tweener.call(this, d, dimensions)
         })

      group.exit().remove()
    })
  }

  return draw
}
